import { DestinationsGalleryProps } from "@/app/components/DestinationsGallery";
import { getStrapiMedia } from "@/app/utils/api-helpers";
import Image from "next/image";
import React from "react";

export const GalleryDesktop = ({ data }: DestinationsGalleryProps) => {
  return (
    <div className="grid grid-cols-4 auto-rows-[284px] gap-2">
      {data?.map((item, index) => (
        <div key={index} className={`relative ${getGridClass(index)}`}>
          <Image
            src={getStrapiMedia(item.img.data[0].attributes.url ?? "") ?? ""}
            alt="Preview photo"
            width={getWidth(index)}
            height={getHeight(index)}
            quality={100}
            className={`rounded-[8px] object-cover w-full h-full ${getPosition(
              index
            )}`}
          />
          {item.text && (
            <span className="absolute bottom-[25px] right-0 text-[#fff] text-[24px] leading-[24px] font-bold uppercase tracking-[0.04em] px-[24px] font-['HalvarBreitschrift']">
              {item.text}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

const getGridClass = (index: number) => {
  const gridMap = [
    "col-span-1 row-span-1",
    "col-span-1 row-span-2",
    "col-span-2 row-span-1",
    "col-span-1 row-span-1",
    "col-span-1 row-span-1",
    "col-span-1 row-span-1",
    "col-span-1 row-span-1",
    "col-span-1 row-span-1",
    "col-span-2 row-span-1",
  ];
  return gridMap[index] || "col-span-1 row-span-1";
};

const getWidth = (index: number) => (index === 1 ? 300 : 200);
const getHeight = (index: number) => (index === 1 ? 400 : 200);

export const getPosition = (index: number) => {
  const positionMap = [
    "object-[-12px] min-[2060px]:object-[0px]",
    "object-[-150px]",
    "object-center",
    "object-center",
    "object-top object-cover",
    "object-center",
    "object-[-63px]",
    "object-[-60px]",
    "object-center",
  ];
  return positionMap[index] || "object-center object-cover";
};
